export default __webpack_public_path__ + "static/media/chroma-logo-dark.0e366f5a.png";